import cn from 'classnames';

import { EColorMap } from '../constants/colorMap';
import { IConDefaultType } from '../types';


export enum HashIconVariant {
  DEFAULT = 'default',
}

export interface IHashIconProps extends IConDefaultType {
  variant?: HashIconVariant;
}

function HashIcon({ color, className, size = 24, rotate, flip, variant = HashIconVariant.DEFAULT }: IHashIconProps) {
  const fill = color || EColorMap.gray_4;
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === HashIconVariant.DEFAULT && (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.1105 2.0062C10.6594 2.06719 11.055 2.56161 10.994 3.11052L10.4507 8H14.4384L15.0062 2.88966C15.0672 2.34075 15.5616 1.94521 16.1105 2.0062C16.6594 2.06719 17.055 2.56161 16.994 3.11052L16.4507 8H20C20.5523 8 21 8.44772 21 9C21 9.55228 20.5523 10 20 10H16.2285L15.784 14H20C20.5523 14 21 14.4477 21 15C21 15.5523 20.5523 16 20 16H15.5618L14.994 21.1105C14.933 21.6594 14.4386 22.055 13.8897 21.994C13.3407 21.933 12.9452 21.4386 13.0062 20.8897L13.5495 16H9.56181L8.99397 21.1105C8.93298 21.6594 8.43856 22.055 7.88966 21.994C7.34075 21.933 6.94521 21.4386 7.0062 20.8897L7.5495 16H4C3.44772 16 3 15.5523 3 15C3 14.4477 3.44772 14 4 14H7.77172L8.21617 10H4C3.44772 10 3 9.55228 3 9C3 8.44772 3.44772 8 4 8H8.43839L9.0062 2.88966C9.06719 2.34075 9.56161 1.94521 10.1105 2.0062ZM13.7717 14L14.2162 10H10.2285L9.78403 14H13.7717Z"
            fill={fill}
          />
        </svg>
      )}
    </i>
  );
}

export default HashIcon;
